import { PayPalScriptProvider } from '@paypal/react-paypal-js'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { isPaypalSettingsOpened } from 'client/reducers/managementReducer'
import { useManagement } from 'client/store'
import {
  CommonPaypalRestButton,
  MAX_PAYPAL_BUTTON_HEIGHT,
  MAX_PAYPAL_BUTTON_WIDTH,
} from 'common/components/entities/paypal-rest-button'
import EntityTypeEnum from 'common/enums/entityTypeEnum'
import React from 'react'
import { useCalculateButtonStyles } from 'src/editor/shared/hooks/use-calculate-button-styles'
import { Button as CommonButton } from 'src/shared/components/button/button'
import { UpsellButtonEntityInterface } from 'src/shared/entities/upsell-button/upsell-button.schema'
import { EntityProps } from '../../../types'

function UpsellButton({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<UpsellButtonEntityInterface>) {
  const showPaypalSettings = useManagement(isPaypalSettingsOpened)

  const {
    calculatedBorder,
    calculatedPadding,
    calculatedFontSize,
    calculatedLineHeight,
    calculatedFontFamily,
    calculatedFontWeight,
    calculatedFontStyle,
    calculatedTextColor,
    calculatedBackground,
    calculatedHover,
  } = useCalculateButtonStyles({
    border: entity.border,
    mobileBorder: entity.mobileBorder,
    padding: entity.padding,
    mobilePadding: entity.mobilePadding,
    buttonType: entity.buttonType,
    fontSize: entity.textFontSize,
    mobileFontSize: entity.mobileTextFontSize,
    lineHeight: entity.lineHeight,
    mobileLineHeight: entity.mobileLineHeight,
    fontFamily: entity.textFontFamily,
    mobileFontFamily: entity.mobileTextFontFamily,
    fontWeight: entity.textFontWeight,
    mobileFontWeight: entity.mobileTextFontWeight,
    fontStyle: entity.textFontStyle,
    mobileFontStyle: entity.mobileTextFontStyle,
    textColor: entity.textColor,
    mobileTextColor: entity.mobileTextColor,
    background: entity.background,
    mobileBackground: entity.mobileBackground,
    backgroundColor: entity.backgroundColor,
    mobileBackgroundColor: entity.mobileBackgroundColor,
    hover: entity.hover,
    mobileHover: entity.mobileHover,
  })

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
      flex
      flexColumn
    >
      {entity.type === EntityTypeEnum.UpsellAgreeButton &&
      showPaypalSettings ? (
        <div style={{ marginTop: 10 }}>
          <PayPalScriptProvider options={{ clientId: 'test' }}>
            <CommonPaypalRestButton
              backgroundColor={entity.paypal?.backgroundColor}
              borderRadius={entity.border}
              disabled
              height={
                entity.width === 'auto' ? MAX_PAYPAL_BUTTON_HEIGHT : undefined
              }
              width={
                entity.width === 'auto' ? MAX_PAYPAL_BUTTON_WIDTH : entity.width
              }
            />
          </PayPalScriptProvider>
        </div>
      ) : (
        <CommonButton
          iconClassNameBefore={entity.iconClassNameBefore}
          iconClassNameAfter={entity.iconClassNameAfter}
          text={entity.text}
          border={calculatedBorder.desktop}
          mobileBorder={calculatedBorder.mobile}
          subText={entity.subText}
          padding={calculatedPadding.desktop}
          mobilePadding={calculatedPadding.mobile}
          alignSelf={entity.alignSelf}
          background={calculatedBackground.desktop}
          mobileBackground={calculatedBackground.mobile}
          attrId={entity.htmlAttrId}
          width={entity.width}
          mobileWidth={entity.mobileWidth}
          textColor={calculatedTextColor.desktop}
          mobileTextColor={calculatedTextColor.mobile}
          mobileSubTextColor={entity.mobileSubTextColor}
          subTextColor={entity.subTextColor}
          textFontSize={calculatedFontSize.desktop}
          mobileTextFontSize={calculatedFontSize.mobile}
          subTextFontSize={entity.subTextFontSize}
          mobileSubTextFontSize={entity.mobileSubTextFontSize}
          textFontFamily={calculatedFontFamily.desktop}
          textFontWeight={calculatedFontWeight.desktop}
          textFontStyle={calculatedFontStyle.desktop}
          subTextFontFamily={entity.subTextFontFamily}
          subTextFontWeight={entity.subTextFontWeight}
          subTextFontStyle={entity.subTextFontStyle}
          mobileTextFontFamily={calculatedFontFamily.mobile}
          mobileTextFontWeight={calculatedFontWeight.mobile}
          mobileTextFontStyle={calculatedFontStyle.mobile}
          mobileSubTextFontFamily={entity.mobileSubTextFontFamily}
          mobileSubTextFontWeight={entity.mobileSubTextFontWeight}
          mobileSubTextFontStyle={entity.mobileSubTextFontStyle}
          boxShadow={entity.boxShadow}
          mobileBoxShadow={entity.mobileBoxShadow}
          lineHeight={calculatedLineHeight.desktop}
          mobileLineHeight={calculatedLineHeight.mobile}
          hover={calculatedHover.desktop}
          mobileHover={calculatedHover.mobile}
        />
      )}
    </BaseEntityNew>
  )
}

export default UpsellButton
